<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  equipment: string[]
}>()

const equipmentItems = computed(() => props.equipment.join(', '))
</script>

<template>
  <section class="bx-content bx-recipe__equipment"
           data-tc="recipe-equipment">
    <h3 class="bx-equipment__title bx-typo--center bx-typo--h4">
      Utensilien
    </h3>
    <p class="bx-typo--center">
      {{ equipmentItems }}
    </p>
  </section>
</template>
